export default "__VITE_ASSET__ClEYCPwA__"